<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Officetrax Work Order Accepts to Push"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Push work order accepts to Officetrax."
      @on-submit="createOfficetraxWorkOrderAcceptsPushImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Officetrax Work Orders Accepts to Push Template.xlsx"
              :file-provider="$importsAPI.getOfficetraxWorkOrdersAcceptsPushTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'OfficetraxWorkOrdersAcceptsPushImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'officetrax-work-orders-accepts-push-imports-add-modal',
    };
  },
  methods: {
    createOfficetraxWorkOrderAcceptsPushImport(data, handleCreate) {
      handleCreate(this.$importsAPI.officetraxWorkOrdersAcceptsPushCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
